import { useSceneEntities } from "@/stores/SceneEntities";
import { useAssetGrabbarsValidate } from "@/scripts/rooms/actions/alcove/AssetGrabbarsValidate";
import { useAssetAccentValidate1 } from "@/scripts/rooms/actions/alcove/AssetAccentValidate1";
export function useAssetRecessSoap2Window(payload, viewport) {

  const sceneEntities = useSceneEntities();
  let wallsfull = sceneEntities.getUIData("wallsfull").enabled;
  let walls34 = sceneEntities.getUIData("walls34").enabled;
  let asset = null;
  if (wallsfull) {
    asset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("wall_interior_center_full_soap_2_window");
  }
  if (walls34) {
    asset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("wall_interior_center_34_soap_2_window");
  }

  let asset2 = sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_soap2");
  let asset3 = sceneEntities.configuratorView.viewportComponent.getViewportAsset("window");

  if (asset) {
    asset.enabled = payload.enabled;
    viewport.setEnabled(asset);

    asset2.enabled = payload.enabled;
    viewport.setEnabled(asset2);

    asset3.enabled = payload.enabled;
    viewport.setEnabled(asset3);
  }


  //need to check full length shelf
 if (payload.enabled) {
    //need to check full length shelf
    let fullLengthShelf = sceneEntities.getUIData("accessories_full_length_shelf")
    if (fullLengthShelf) {
      if (fullLengthShelf.enabled) {
        fullLengthShelf.enabled = false;
        let asset4 = sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_full_length_shelf");
        asset4.enabled = false;
        viewport.setEnabled(asset4);
      }
    }
  }


  useAssetGrabbarsValidate(null, viewport)
  useAssetAccentValidate1(null, viewport)
}
